import React from 'react';
import ServicePageLayout from '../../components/ServicePageLayout';
import { copyrightRegisterData } from '../../data/serviceData';

const CopyrightRegister = () => {
  return <ServicePageLayout data={copyrightRegisterData} />;
};

export default CopyrightRegister;
